import {apiSend, updateBrowserHistory} from "@util/api";

const {trialListingApi} = API;
const {langCode, languageName} = GLOBAL;
const {phase} = LABELS?.trialLabels || ''

export default {
    taSearch(query, updateHistory = true) {
        query.lang = langCode;
        query.phase = phase
        query.language = languageName

        this.loading = true;
        this.query = query;
        // Reset the total for the pagination to update the currentPage
        this.resultsValues.total = 0;

        apiSend(trialListingApi, query)
            .then(({data, status}) => {
                if (status === 200) {
                    this.resultsValues = {
                        ...data,
                        page: this.query?.page,
                    }
                    this.showResults = data.posts[query.page - 1] || []
                }
            })
            .finally(() => (this.loading = false));

        const queryParams = {};
        this.query?.page && (queryParams.pages = query?.page || this.query?.page)
        this.status && (queryParams.status = this.status)
        delete query.language;

        updateHistory && updateBrowserHistory(queryParams)
    },
    handlePage() {

    }
}
